import { useTranslation } from 'react-i18next';
import { useUserRoles } from '@anytag/auth';
import { InfluencerAvatar } from '@anytag/shared-molecules';
import { getSocialMediaTextLink } from '@anytag/shared-utils';
import { SupportedSocialMediaType } from '@anytag/shared-types';
import { Anchor, MediaPreview, SocialIcon, TextCutter } from '@anytag/shared-atoms';
import { useGenerateInfluencerProfileLink, usePostDetailsParam } from '@anytag/shared-hooks';
import { TikTokCampaignReportRowData } from './types';

type InfluencerPostProps = Pick<TikTokCampaignReportRowData, 'influencerInfo' | 'postInfo'>;

export const InfluencerPost = ({ influencerInfo, postInfo }: InfluencerPostProps) => {
  const { t } = useTranslation();
  const { isAdvertiserFromTikTok } = useUserRoles();
  const { setPostDetailsParam } = usePostDetailsParam();
  const { generateProfileLink } = useGenerateInfluencerProfileLink({ disabled: isAdvertiserFromTikTok });

  return (
    <div className="flex items-center justify-between gap-2">
      <Anchor className="flex flex-4 items-center gap-2" {...generateProfileLink(influencerInfo?.id || '')}>
        <InfluencerAvatar
          size="48px"
          src={influencerInfo?.thumbNail}
          className="rounded-sm border border-border"
          asChild
        />
        <TextCutter lines={2} className="text-base" text={influencerInfo?.name || '-'} />
      </Anchor>

      {postInfo && (
        <div className="flex flex-6 items-center">
          <MediaPreview
            objectFit="contain"
            caption={postInfo.content}
            captionProps={{ margin: 4 }}
            src={postInfo.thumbNail || ''}
            className="size-10 rounded-sm"
            onClick={() => setPostDetailsParam(postInfo.id)}
          />
          <div className="ml-2 flex min-w-25 justify-between gap-2">
            <div>
              <TextCutter
                lines={2}
                text={postInfo.content || '-'}
                onClick={() => setPostDetailsParam(postInfo.id)}
                className="cursor-pointer text-sm leading-[12px]"
              />
              {postInfo.postUrl ? (
                <Anchor
                  target="_blank"
                  variant="blue"
                  href={postInfo.postUrl}
                  css={{ display: 'flex', alignItems: 'center', marginTop: '4px', fontSize: '12px' }}
                >
                  <SocialIcon size="16px" type={SupportedSocialMediaType.TIKTOK} css={{ marginRight: '4px' }} />
                  {t('View on', { socialMedia: getSocialMediaTextLink(SupportedSocialMediaType.TIKTOK) })}
                </Anchor>
              ) : null}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
